















import { computed, defineComponent, getCurrentInstance, ref } from "@vue/composition-api";
import { Page } from "@scrile/api-provider/dist/api/PageProvider";
import useStateRedirectPath from "@/hooks/useStateRedirectPath";
import providers from "@/lib/api";

export default defineComponent({
  name: "FooterPolicy",
  setup() {
    const { stateRedirectPath } = useStateRedirectPath();
    const vm = getCurrentInstance();
    const pages = ref<Page[]>([]);
    const contactUsLocation = computed(() => vm?.$router.resolve({ name: "messages", params: { userId: "1" } }));

    const contactClick = () => {
      stateRedirectPath.value = contactUsLocation.value?.location ?? null;
      vm?.$router.push({ name: "login" });
    };

    const getData = async () => {
      pages.value = await providers.PageProvider.find();
    };
    getData();

    return { pages, contactUsLocation, contactClick };
  },
});
